import { render } from "./Registrierung.vue?vue&type=template&id=5779529c"
import script from "./Registrierung.vue?vue&type=script&lang=js"
export * from "./Registrierung.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__